import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const kajeEntry = createAsyncThunk('kajeEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertKajeEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const kajePressIssueInward = createAsyncThunk('kajePressIssueInward', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertKajePressIssueInward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchReturnMemo = createAsyncThunk('fetchStitchReturnMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStitchReturnMemoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchKajeEmplist = createAsyncThunk('fetchKajeEmplist', async (id) => {
    try {
        const endpoint = id ? `getKajeEmplist&empId=${id}` : 'getKajeEmplist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchKajeMemoNo = createAsyncThunk('fetchKajeMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getKajeMemoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchKajeRegister = createAsyncThunk('fetchKajeRegister', async (id) => {
    try {
        const endpoint = id ? `getKajeRegister&kId=${id}` : 'getKajeRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchKajeRegReturn = createAsyncThunk('fetchKajeRegReturn', async (id) => {
    try {
        const endpoint = id ? `getKajeRegister&sreId=${id}` : 'getKajeRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const KajeApiSlice = createSlice({
    name: 'KajeDatalist',
    initialState: {
        isLoading: false,
        reMemo: null,
        emplist: null,
        kjMemo: null,
        kjlist: null,
        kjreturn: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStitchReturnMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchReturnMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.reMemo = action.payload;
        });
        builder.addCase(fetchStitchReturnMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchKajeEmplist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchKajeEmplist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.emplist = action.payload;
        });
        builder.addCase(fetchKajeEmplist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchKajeMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchKajeMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.kjMemo = action.payload;
        });
        builder.addCase(fetchKajeMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchKajeRegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchKajeRegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.kjlist = action.payload;
        });
        builder.addCase(fetchKajeRegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchKajeRegReturn.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchKajeRegReturn.fulfilled, (state, action) => {
            state.isLoading = false;
            state.kjreturn = action.payload;
        });
        builder.addCase(fetchKajeRegReturn.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

    }
});

export default KajeApiSlice.reducer;
